import { useTheme } from './useTheme.ts';

/* Inline SVGs (not an icon package) — shared/ stays dependency-free for
   both consuming builds. */
function Sun() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
    </svg>
  );
}

function Moon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
    </svg>
  );
}

/**
 * Light/dark chrome toggle (the slide preview itself is always black).
 *
 * Two shapes, because the two surfaces want different hit targets. In the bar
 * it is the bare 28px icon button, which is the whole control and correct
 * there. In the mobile sheet it renders the ENTIRE row — pass `inSheet`, and
 * declare `ownRow` on the header action so the sheet does not wrap it — because
 * a 28px target inside a 44px row that looks tappable everywhere is a row that
 * misses nine taps in ten.
 */
export default function ThemeToggle({ inSheet = false }: { inSheet?: boolean } = {}) {
  const [theme, toggle] = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  const icon = theme === 'dark' ? <Sun /> : <Moon />;
  if (inSheet) {
    return (
      <button type="button" className="app-sheet__row" onClick={toggle} aria-label={`Switch to ${next} mode`}>
        <span className="app-sheet__row-label">
          Appearance
          {/* The house rule that a control says what its current answer means.
              The icon shows where a tap GOES; this says where it already is. */}
          <span className="app-sheet__row-hint">{theme === 'dark' ? 'Dark' : 'Light'}</span>
        </span>
        <span className="app-sheet__row-control">{icon}</span>
      </button>
    );
  }
  return (
    <button
      type="button"
      className="iconbtn"
      onClick={toggle}
      title={`Switch to ${next} mode`}
      aria-label={`Switch to ${next} mode`}
    >
      {icon}
    </button>
  );
}
